'use client';

import Link from 'next/link';

type YearNavigationProps = {
  year: number;
  basePath?: string;
  setYearValue?: (year: number) => void;
};

const MIN_YEAR = 2020;
const MAX_YEAR = 2050;

const YearNavigation = ({ year, basePath = '' }: YearNavigationProps) => {
  const canGoPrev = year > MIN_YEAR;
  const canGoNext = year < MAX_YEAR;

  return (
    <div className="flex justify-between items-center">
      <div className="flex justify-center items-center gap-4">
        {canGoPrev ? (
          <Link
            href={`${basePath}${year - 1}`}
            className="text-2xl px-4 py-2 hover:bg-gray-100 rounded"
          >
            ←
          </Link>
        ) : (
          <span className="text-2xl px-4 py-2 text-gray-400 cursor-not-allowed">←</span>
        )}

        <span className="text-2xl font-bold">{year}</span>

        {canGoNext ? (
          <Link
            href={`${basePath}${year + 1}`}
            className="text-2xl px-4 py-2 hover:bg-gray-100 rounded"
          >
            →
          </Link>
        ) : (
          <span className="text-2xl px-4 py-2 text-gray-400 cursor-not-allowed">→</span>
        )}
      </div>
    </div>
  );
};

export default YearNavigation;
